import Highcharts from 'highcharts';
import {numberRange} from './utilities';

export const figure35 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'column',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
        },
        // line: {
        //   stacking: 'normal',
        //   // shared options for all line series
        // }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: numberRange(1995,2018),
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: [{
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 7000,
        min: 0,
        tickInterval: 1000,
        gridLineWidth: 2,
        floor: 0,
        title: {
          text: 'MILLONES DE USD',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        // //headerFormat: '<div>{point.key}</div>',
        // valueSuffix: '%',
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
      series: [
        {
            type: 'column',
            name: 'Miembros en desarrollo',
            color: '#c8c8c8',
            borderColor: '#a4a4a4',
            borderWidth: 1,
            data: [
                107.3,
                125.4,
                162.4,
                91.6,
                75.5,
                88.9,
                68,
                64.7,
                66.9,
                62.9,
                94.4,
                82.5,
                111.5,
                130.3,
                170.1,
                69.8,
                81.2,
                64.7,
                54.6,
                50.1,
                38.5,
                48.6,
                74.1,
                18
            ]
        },
        {
            type: 'column',
            name: 'Miembros desarrollados',
            color: '#f5b195',
            data: [
                4479.4,
                5114.2, 
                4457.6, 
                5372.5,
                6616.3,
                2887.6,
                2596.6,
                3270.4,
                3778.9,
                3644.6,
                2640.2,
                2088.5,
                1373.3,
                896.3,
                754.6,
                434.8,
                402.6,
                284.7,
                202.3,
                180.6,
                179.2,
                157.9,
                119.4,
                119.8
            ]
        },
        {
          type: 'spline',
          name: null,
          color: '#a4a4a4',
          dashStyle: 'ShortDash',
          marker: {
            enabled: false
          },
          tooltip: {
            pointFormatter: function() {
              return '';
            }
          },
          data: [
            107.3,
            125.4,
            162.4,
            91.6,
            75.5,
            88.9,
            68,
            64.7,
            66.9,
            62.9,
            94.4,
            82.5,
            111.5,
            130.3,
            170.1,
            69.8,
            81.2,
            64.7,
            54.6,
            50.1,
            38.5,
            48.6,
            74.1,
            18
        ]
      },
      {
        type: 'spline',
        name: null,
        color: '#a4a4a4',
        dashStyle: 'ShortDash',
        tooltip: {
          pointFormatter: function() {
            return '';
          }
        },
        marker: {
          enabled: false
        },
        data: [
          4479.4,
          5114.2, 
          4457.6, 
          5372.5,
          6616.3,
          2887.6,
          2596.6,
          3270.4,
          3778.9,
          3644.6,
          2640.2,
          2088.5,
          1373.3,
          896.3,
          754.6,
          434.8,
          402.6,
          284.7,
          202.3,
          180.6,
          179.2,
          157.9,
          119.4,
          119.8
        ]
    },
      ]
};
